import { GroupBase } from 'react-select';

import type { IOptionItem } from '@wyz/types';
import { SelectField as BaseSelectField, SelectFieldProps } from '@wyz/ui';
import { Trans } from '~/common/context';

function SelectField<
  IsMulti extends boolean,
  Option extends IOptionItem<string | number> = IOptionItem<string | number>,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Omit<SelectFieldProps<IsMulti, Option, Group>, 'Trans'>) {
  return <BaseSelectField {...props} Trans={Trans} />;
}

export default SelectField;
